import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

const DARK = { "--base": "24 26% 8%", "--base-2": "24 20% 12%", "--ink": "40 38% 91%" };

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("pmr_theme") || "light");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
      Object.entries(DARK).forEach(([k, v]) => root.style.setProperty(k, v));
    } else {
      root.classList.remove("dark");
      Object.keys(DARK).forEach((k) => root.style.removeProperty(k));
    }
    localStorage.setItem("pmr_theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
